import React from 'react';
import { connect } from 'react-redux';
import { selectPaymentCollectionType } from 'src/utils/selectors/select-flags';
import type { RootState } from 'src/redux';
import type { PaymentCollectionType } from 'src/utils/selectors/select-flags';

import ChangePayment from './ChangePayment';
import ChangePaymentLegacy from './ChangePaymentLegacy';

export type ChangePaymentContainerProps = {
  paymentCollectionType: PaymentCollectionType;
};

const ChangePaymentKinds = {
  'card-element': ChangePaymentLegacy,
  'payment-element': ChangePayment,
};

const ChangePaymentContainer: React.FC<ChangePaymentContainerProps> = ({ 
  paymentCollectionType,
}) => {
  const ChangePayment = ChangePaymentKinds[paymentCollectionType];
  
  return <ChangePayment />;
};

const mapStateToProps = (state: RootState) => ({
  paymentCollectionType: selectPaymentCollectionType(state),
});

export default connect(mapStateToProps)(ChangePaymentContainer); 